import { Injectable } from '@angular/core';

import { CustomerSubType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomerSubTypeService extends TmsWebBaseEditService<CustomerSubType, CustomerSubType> {
  constructor() {
    super('CustomerSubType', $localize`Customer Sub Type`);
  }
}
